export const path = process.env.REACT_APP_STAGE === 'PROD'
    ? 'https://uniacco.com'
    : 'http://localhost:8000';

export const domain = process.env.REACT_APP_STAGE === 'PROD'
    ? '.uniacco.com'
    : 'localhost';

export const authPath = `${path}/api/v1/token`

export function getLoginPath() {
    return path + '/' + 'api/v1/token/';
}

export const websitePath = 'https://uniacco.com/login'

export const getLeadList = `${path}/api/v1/crm/leads`

export const getPartnerLeadList = (page, size) => `${path}/api/v1/partners/leads?page=${page}&page_size=${size}`

export const getAgentAuthPath = () => `${path}/api/v1/crm/agents/auth`

export const getPartnerAuthPath = () => `${path}/api/v1/partners/auth`

export const getAgentLeads = () => `${path}/api/v1/crm/agents/leads`

export const getAgentTasks = () => `${path}/api/v1/crm/agents/tasks`

export const getRedashVisuals = () => `${path}/api/v1/crm/redash/visualisation`

export const getBookingData = (lead_id) => `${path}/api/v1/crm/leads/${lead_id}/booking-form`

export const getDateTime = `${path}/api/v1/crm/countries/get-date-time`

export const getAdminDasboard = `${path}/api/v1/crm/admin/agent-data`

export const conversionFormPath = id => `${path}/api/v1/crm/leads/${id}/conversion-form`

export const bookingLinkFormPath = (value) => `${path}/api/v1/crm/booking-link?lead_id=${value.lead_id}&prop_code=${value.prop_code}&room_type=${value.room_type}&deposit=${value.deposit_amount}`

export const getCityPath = country => `${path}/api/v1/countries/${country}/cities`;

export const getProperties = city => `${path}/api/v1/cities/${city}/prop-list`;

export const getRoomTypes = (city, prop) => `${path}/api/v1/uk/${city}/${prop}`

export const getSendSMSPath = () => `${path}/api/v1/crm/sms`

export const getLogsPath = () => `${path}/api/v1/crm/calls/logs`

export const getTimelinePath = (id) => `${path}/api/v1/crm/leads/${id}/timeline`

export const getTagsList = `${path}/api/v1/leads/tags`

export const addTags = (leadId) => `${path}/api/v1/crm/leads/${leadId}/tags`

export const getLeadFormPath = () => `${path}/api/v1/leads/create`

export const getAWSVisuals = (metric) => `https://4cftmq9o64.execute-api.ap-south-1.amazonaws.com/default/team-EC2Graphs?metricwidget=${metric}`

export const getManagers = () => `${path}/api/v1/prop-managers`

export const getManagerProps = (code) => `${path}/api/v1/prop-managers/${code}/properties`

export const getManagerPropPhones = (manager_code,property_code) => `${path}/api/v1/prop-managers/${manager_code}/properties/${property_code}/contacts`

export const getLeadAnalytics = (leadId) => `${path}/api/v1/crm/leads/${leadId}/analytics`

export const getPartnerLeadFormPath = () => `${path}/api/v1/partners/leads`

export const getAutoSuggestPath = input => `${path}/api/v1/scripts/autosuggest?input=${input}`;

export const getCountriesPath = `${path}/api/v1/countries`;

export const uploadFilePath = `${path}/api/v1/partners/create-bulk-leads`

export const getS3StaticFile = name => `https://dxh0xeyowrxer.cloudfront.net/dashboard/${name}`

export const getUniversityPath = country => `${path}/api/v1/universities?country=${country}`;

export const UniversitiesPath = `${path}/api/v1/partners/universities-list`

export const exportLeadsData = `${path}/api/v1/partners/leads/export`